<template>
  <div class="vx-row">
    <div
      v-if="coachingExperience.total === 0"
      class="vx-card w-full no-box-shadow overflow-hidden mb-base"
    >
      <!---->
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div>
          <div
            class="con-vs-avatar mx-auto my-6 block 80px"
            style="width: 250px; height: 200px; background: white/*rgb(195, 195, 195)*/;"
          >
            <!---->
            <div class="">
              <img
                src="@/assets/Illustrations/Ill_Skill Details_Progress.svg"
                alt=""
                style="color: grey;"
              />
            </div>
          </div>
          <div class="p-6 text-center">
            <!--<span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
              style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
            >
              <img src="@/assets/Illustrations/Ill_Skill Details_Progress.svg" alt="attribute" class="skill-icon" />
            </span>-->
            <div class="truncate t-sd mb-2">
              <h5 class="mb-2" style="color: #079E9A;">
                {{ $t("coach.coachingExperienceData.ced1") }}
              </h5>
              <span>{{ $t("coach.coachingExperienceData.ced2") }}</span>
            </div>
            <!--<vs-button
              v-if="progressStatus !== 'complete'"
              @click="addProgress"
              >{{ $t("skillDetails.progress.p3") }}</vs-button
            >-->
          </div>
          <!---->
        </div>
        <!----><!---->
      </div>
    </div>
    <div v-else class="vx-card w-full no-box-shadow overflow-hidden mb-base">
      <!---->
      <div class="vx-card__collapsible-content vs-con-loading__container p-2">
        <div class="p-6 pl-0">
          <h5>{{ $t("coach.coachingExperienceData.ced3") }}</h5>
        </div>
        <div
          v-if="
            latestManagerSupport !== null &&
              latestRelationship !== null &&
              latestResourceAvailability !== null
          "
          class="mt-3"
        >
          <CoachingExperienceChart
            :managerSupport="latestManagerSupport"
            :relationship="latestRelationship"
            :resourceAvailability="latestResourceAvailability"
          />
        </div>
        <div class="p-6 text-center">
          <!--<vs-button
            v-if="progressStatus !== 'complete' && userType === 'trainee'"
            @click="addProgress"
            >{{ $t("skillDetails.progress.p3") }}</vs-button
          >-->
        </div>
        <div class="p-6 pl-0">
          <h5>{{ $t("coach.coachingExperienceData.ced4") }}</h5>
        </div>
        <div v-for="pmr in coachingExperience" :key="pmr.id" class="mb-base">
          <span style="font-size: 10px; color: #9D9D9D;" class="ml-1"
            >{{ $t("skillDetails.progress.p6") }}:
            {{ formatDate(pmr.createdAt) }}</span
          >
          <CoachingExperienceHorizontal
            :managerSupport="pmr.managerSupport*10"
            :relationship="pmr.relationship*10"
            :resourceAvailability="pmr.resourceAvailability*10"
          />
        </div>
        <!----><!---->
      </div>
    </div>
  </div>
</template>

<script>
import CoachingExperienceChart from './CoachingExperienceChart'
import CoachingExperienceHorizontal from './CoachingExperienceHorizontal'

export default {
  name: "CoachingExperienceData",
  components: { CoachingExperienceHorizontal, CoachingExperienceChart  },
  data() {
    return {
      userType: this.$store.state.AppActiveUser.userType,
      coachingExperience: {},
      latestManagerSupport: null,
      latestRelationship: null,
      latestResourceAvailability: null
    };
  },
  methods: {
    formatDate(createdAt) {
      let date = new Date(createdAt);
      date = `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`;
      return date;
    },
    /*addProgress() {
      this.$router.push({
        name: "competency-progress",
        params: {
          traineeCompetenciesId: this.$route.params.traineeCompetenciesId
        }
      });
    }*/
  },
  mounted() {},
  created() {
    //const id = this.$route.params.traineeCompetenciesId;
    const id = this.$store.state.coachingExperience.sidebarId;
    const query = {
      traineeCoachId: id,
      $sort: { createdAt: -1 }
    };
    this.$store
      .dispatch("coachingExperience/fetchCoachingExperience", { query })
      .then(res => {
        console.log("found coaching experience", res);
        this.coachingExperience = res;
        if (res.total > 0) {
          this.latestManagerSupport = res.data[0].managerSupport*10;
          this.latestRelationship = res.data[0].relationship*10;
          this.latestResourceAvailability = res.data[0].resourceAvailability*10;

          this.coachingExperience = res.data;
          // this.competencyProgress.shift()
        }
      })
      .catch(err => {
        console.log("error fetching coaching experience", err);
      });
  }
};
</script>

<style scoped>
.no-box-shadow {
  box-shadow: none !important;
}
.t-sd {
  white-space: normal !important;
}
.skill-icon {
  width: 25px;
  height: 25px;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
</style>
